import { j as _slicedToArray } from './_rollupPluginBabelHelpers-047e4aae.js';
import React, { useRef, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import 'react-dom';
import './_rollupPluginBabelHelpers-b9ad31fa-7ae21c08.js';
import 'styled-components';
import './withTooltip-92e0dfed.js';
import '@styled-system/space';
import '@styled-system/color';
import '@styled-system/border';
import '@styled-system/variant';
import '@styled-system/typography';
import { I as Icon } from './index-28a062d6-3659b895.js';
import { L as Loader } from './loader-4d85b9a1.js';
import Bole from './bole.js';
import { s as styleInject } from './style-inject.es-1f59c1d0.js';

/*
 * Base URL cannot be based on env because, all deployed builds have production build
 * So, making it based on window location
 */
var getBaseUrl = function getBaseUrl() {
  var productionUrl = "https://support.haptikapi.com";
  var stagingUrl = "https://staging.hellohaptik.com";
  var excludedEnvironments = ["dev", "prestaging", "netlify"];
  var pageOrigin = window.location.origin;
  var otherEnv = false;

  /**
   * Regex check to verify if pageOrigin / current location
   * contains haptikapi.com or hellohaptik.com to
   * support multiple CAS/env's
   *
   * As of now Haptik, Jio and Singapore env's are present
   * hence, irrespective of them, this check will help us determine
   * where to point the bot (staging/prod).
   */
  var regex = /\b(?::\/\/)?haptikapi.com|hellohaptik.com+\.*?/g;

  /**
   * Check if current env is either
   * dev, prestaging or netlify
   */
  excludedEnvironments.forEach(function (item) {
    if (pageOrigin.includes(item)) {
      otherEnv = true;
    }
  });

  // show production bot only for prod and staging environment
  // rest, which includes dev, prestaging, netlify etc, will have staging bot
  return regex.test(pageOrigin) && !otherEnv ? productionUrl : stagingUrl;
};
var getUrl = function getUrl() {
  var windowUrl = window.location.href;
  return windowUrl.split("/").splice(2, 4);
};

var htmlContent = "<html>\n  <head>\n    <title>Platform support bot</title>\n    <meta charset=\"UTF-8\" />\n    <meta content=\"width=device-width; initial-scale=1.0;\" name=\"viewport\" />\n  </head>\n  <style>\n    iframe {\n      border : none;\n    }\n  </style>\n  <body>\n    <script>\n      var haptikInitSettings = {\n        \"business-id\": 1307,\n        \"client-id\": \"79ca4f4f2260fa0999f770ba5d39ae68d7b75d8b\",\n        \"base-url\": \"%base_url\",\n        \"widget-positioning\": \"bottom-left\",\n        \"signup-type\": \"guest\",\n        \"custom-button\": true,\n        mode: \"fsm\",\n      };\n    </script>\n    <script\n      type=\"text/javascript\"\n      charset=\"UTF-8\"\n      src=\"https://toolassets.haptikapi.com/platform/javascript-xdk/production/loader.js\"\n    ></script>\n  </body>\n</html>";
var businessId = "1307";
var clientId = "79ca4f4f2260fa0999f770ba5d39ae68d7b75d8b";

var css_248z = ".PlatformSupport_platformSupport__2A_4d {\n  display: flex;\n  flex-direction: column;\n  width: 400px;\n  height: 90vh;\n  border-radius: 8px;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);\n  overflow: hidden; }\n  .PlatformSupport_platformSupport__2A_4d .PlatformSupport_closeBtn__1PO68 {\n    display: flex;\n    justify-content: flex-end;\n    box-sizing: border-box;\n    padding: 5px;\n    background-color: white; }\n  .PlatformSupport_platformSupport__2A_4d iframe {\n    width: 100%;\n    height: 100%;\n    border: none;\n    position: relative;\n    bottom: 0;\n    background-color: lightgrey; }\n";
var styles = {"platformSupport":"PlatformSupport_platformSupport__2A_4d","closeBtn":"PlatformSupport_closeBtn__1PO68"};
styleInject(css_248z);

/**
 * TODO: Remove component once migrated to v2
 */
var PlatformSupport = function PlatformSupport(_ref) {
  var className = _ref.className,
    onClose = _ref.onClose;
  var _iframe = useRef(null);
  useEffect(function () {
    if (_iframe && _iframe.current) {
      var frame = _iframe.current.contentWindow || _iframe.current.contentDocument.document || _iframe.current.contentDocument;
      var content = htmlContent.replace("%base_url", getBaseUrl());
      frame.document.open();
      frame.document.write(content);
      frame.document.close();
    }
    return function () {
      onClose && onClose();
      _iframe.current = null;
    };
  });
  var handleOnClose = useCallback(function () {
    // trigger unload event, to retain chat history in xdk
    if (onClose) {
      _iframe.current.contentWindow.location.reload();
      onClose();
    }
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.platformSupport, " ").concat(className)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.closeBtn,
    onClick: handleOnClose
  }, /*#__PURE__*/React.createElement(Icon, {
    src: "close"
  })), /*#__PURE__*/React.createElement("iframe", {
    title: "template-sdk-support",
    ref: _iframe
  }));
};
PlatformSupport.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func
};
PlatformSupport.defaultProps = {
  onClose: null,
  className: ""
};
PlatformSupport.__docgenInfo = {
  "description": "TODO: Remove component once migrated to v2",
  "methods": [],
  "displayName": "PlatformSupport",
  "props": {
    "onClose": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "className": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};

var useScript = function useScript(url) {
  useEffect(function () {
    var script = document.createElement("script");
    script.src = url;
    script.crossorigin = true;
    document.body.appendChild(script);
    return function () {
      document.body.removeChild(script);
    };
  }, [url]);
};

var css_248z$1 = ".xdk-iframe {\n  margin-left: 60px; }\n";
styleInject(css_248z$1);

var PlatformSupportV2 = function PlatformSupportV2(_ref) {
  var customButton = _ref.customButton,
    _ref$username = _ref.username,
    username = _ref$username === void 0 ? "Guest" : _ref$username,
    _ref$useremail = _ref.useremail,
    useremail = _ref$useremail === void 0 ? "" : _ref$useremail,
    _ref$toolname = _ref.toolname,
    toolname = _ref$toolname === void 0 ? "home" : _ref$toolname,
    authcode = _ref.authcode,
    onShow = _ref.onShow,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? "bottom-left" : _ref$position,
    withLoader = _ref.withLoader;
  var _React$useState = React.useState(""),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    url = _React$useState2[0],
    setUrl = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isLoading = _React$useState4[0],
    setIsLoading = _React$useState4[1];
  window.haptikInitSettings = {
    "business-id": businessId,
    "client-id": clientId,
    "base-url": getBaseUrl(),
    "custom-button": true,
    "widget-positioning": position,
    "signup-type": "third_party"
  };
  useScript(url);
  var props = {
    onClick: useCallback(function () {
      setIsLoading(true);
      if (window.HaptikSDK) {
        window.HaptikSDK.show();
        onShow && onShow();
        setIsLoading(false);
      } else {
        setUrl("https://toolassets.haptikapi.com/platform/javascript-xdk/production/loader.js");
      }
    })
  };
  function HaptikSignup() {
    window.HaptikSDK.signup({
      username: username,
      auth_id: username,
      auth_code: authcode,
      email: useremail,
      custom_data: {
        url: getUrl(),
        tool_name: toolname
      }
    }, function (status, error) {
      if (status) {
        console.log("Support bot loaded successfully!!");
        window.HaptikSDK && window.HaptikSDK.show();
        onShow && onShow();
      } else {
        Bole.error("Unable to load Support bot!!", error);
      }
      setIsLoading(false);
    });
  }
  React.useEffect(function () {
    document.addEventListener("haptik_sdk", HaptikSignup);
    return function () {
      document.removeEventListener("haptik_sdk", HaptikSignup);
    };
  }, []);
  if (isLoading && withLoader) {
    return /*#__PURE__*/React.createElement(Loader, {
      themed: true,
      size: 24
    });
  }
  return /*#__PURE__*/React.cloneElement(customButton, props);
};
PlatformSupportV2.propTypes = {
  customButton: PropTypes.element.isRequired
};
PlatformSupportV2.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "PlatformSupportV2",
  "props": {
    "username": {
      "defaultValue": {
        "value": "\"Guest\"",
        "computed": false
      },
      "required": false
    },
    "useremail": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "required": false
    },
    "toolname": {
      "defaultValue": {
        "value": "\"home\"",
        "computed": false
      },
      "required": false
    },
    "position": {
      "defaultValue": {
        "value": "\"bottom-left\"",
        "computed": false
      },
      "required": false
    },
    "customButton": {
      "type": {
        "name": "element"
      },
      "required": true,
      "description": ""
    }
  }
};

export { PlatformSupport as P, PlatformSupportV2 as a };
